import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M15.808 10.833a5.208 5.208 0 1 1-10.417 0 5.208 5.208 0 0 1 10.417 0Zm-1.458-3.75.625-.625M10.6 5.417V3.958m0 0H8.725m1.875 0h1.875M10.6 8.125v2.917" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);